import React, {memo, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import styles from './index.less';
import { Card } from 'antd';
import {NUMBER_FORMAT} from '@/modules/audits/contants/audits';
import classNames from 'classnames';
import Incidents from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType/Incidents';

const PoolsNumbers = ({question, isIncidence, title, idx}) => {
  const {t} = useTranslation('templates');
  const value = useMemo(() => question?.value, [question?.value]);
  
  const label = useMemo( () => {
    return question?.type === 'pools_reported' ? t('details.poolsReported')
      : question?.type === 'pools_audited' ? t('details.poolsAudited')
        : question?.type === 'pools_not_audited' ? t('details.poolsNotudited') : '';
  }, [question?.type, t]);

  if(isIncidence){
    return <Card
      key={idx}
      className={classNames(styles.templateNumberCard, idx !==0 && 'mt-2')}
      bodyStyle={{padding: '6px'}}
    >
      <div>
        {title}
      </div>
      <div className={'font-bold'}>{question?.name || question?.label}</div>
      <div className="mt-1">
        {`${value} ${NUMBER_FORMAT?.[question?.text?.answerType] || ''}`}
      </div>
    </Card>;
  }

  return (
    <Card
      className={styles.templateNumberCard}
      bodyStyle={{padding: '6px'}}
      id={'question-view-' + question?._id}
    >
      <div className="mb-3 font-bold">
        {question?.name || label}
      </div>
      <div className="custom-form-big mb-3">
        {value ? `${value} ${NUMBER_FORMAT?.[question?.text?.answerType] || ''}` : 'N/A'}
      </div>
      <Incidents data={question?.issuesAudit} question={question} hasIssues={question?.issuesAudit?.length}/>
    </Card>
  );
};

PoolsNumbers.propTypes = {
  question: PropTypes.object,
  title: PropTypes.string,
  idx: PropTypes.number,
  isIncidence: PropTypes.bool,
};
PoolsNumbers.defaultProps = {
  question: {},
};

export default memo(PoolsNumbers);
